<template>
    <el-drawer :modal="false" 
        :title="'Case: '+ _gHlp.getValue(product,'prod_case_no','N/A') "
        :visible.sync="is_visible"
        class="case-details-drawer"
        size="45%"
				@close="hide"
    >	
			<div style="min-height:300px" v-loading="is_loading" element-loading-text="Optimize Case Detail...">
				<DisableCaseCard :product="product"/>
        <b-container v-if="!_gHlp.isEmpty(product)" >
            <el-collapse v-model="activeNames">
                <el-collapse-item name="1" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Property Details</h3>
                    </div>
                    <PropertyDetails :product="product" :pmp_case_details="pmp_case_details" :cover_image="cover_image"/>
                </el-collapse-item>
                <el-collapse-item name="2" class="my-3">
                    <div slot="title" class="collapse-header w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <h3 class="mb-0">Bank</h3>
                            <el-button @click="showAddBankModal" class="float-right py-0 pr-3 text-primary" type="text">+ Add Bank</el-button>
                        </div>
                    </div>
                    <BankDetails :product="product"/>
                </el-collapse-item>
								<el-collapse-item name="6" class="my-3" v-if="!UNEDITABLE_STATUS.includes(product.prod_main_status)">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Case Progress</h3>
                    </div>
                    <CaseProgress :step_status="product.prod_main_status_label"/>
                </el-collapse-item>
                <el-collapse-item name="3" class="my-3">
                    <div slot="title" class="collapse-header">
                        <h3 class="mb-0">Lawyer</h3>
                    </div>
                    <LawyerDetails :lawyer_details="pmp_case_details" v-if="product.product_detail.prod_pm_property_src != 'HESTIA'"/>
                    <LawyerDetails :lawyer_details="lawyer_trackings" :is_hestia="true" v-else/>
                </el-collapse-item>
                <b-row>
                    <b-col cols="12" md="6">
                        <el-collapse-item name="4" class="my-3">
                            <div slot="title" class="collapse-header">
                                <h3 class="mb-0">SPA Remark</h3>
                            </div>
                            <SpaRemarks :spa_remarks="pmp_case_details.spa.remarks" :prod_id="product.prod_id" v-if="pmp_case_details && product.product_detail.prod_pm_property_src != 'HESTIA'" @refresh-lawyer-detail="getPMPCaseDetails()"/>
                            <SpaRemarks :spa_remarks="lawyer_trackings.spa.remarks" :prod_id="product.prod_id" :is_hestia="true" v-else @refresh-lawyer-detail="getHestiaLawyerTracking()"/>
                        </el-collapse-item>
                    </b-col>
                    <b-col cols="12" md="6">
                        <el-collapse-item name="5" class="my-3">
                            <div slot="title" class="collapse-header">
                                <h3 class="mb-0">LA Remark</h3>
                            </div>
                            <LaRemarks :la_remarks="pmp_case_details.la.remarks" :prod_id="product.prod_id" v-if="pmp_case_details && product.product_detail.prod_pm_property_src != 'HESTIA'" @refresh-lawyer-detail="getPMPCaseDetails()"/>
                            <LaRemarks :la_remarks="lawyer_trackings.la.remarks" :prod_id="product.prod_id" :is_hestia="true" v-else @refresh-lawyer-detail="getHestiaLawyerTracking()"/>
                        </el-collapse-item>
                    </b-col>
                </b-row>
            </el-collapse>
						<b-row v-if="checkCanGenerateCommision(product)">
							<b-col md="12" class="mx-auto text-center mt-4 pt-2">
								<b-button variant="primary" type="button" @click="generateProductCommission(product)">Generate Commission</b-button>
							</b-col>
						</b-row>
						<b-row v-if="!_gHlp.isEmpty(product.prod_commission_at)">
							<b-col md="12" class="mx-auto text-center mt-4 pt-2">
								<p class="text-danger">PRODUCT SALES COMMISSION HAS BEEN GENERATED AT {{ _gHlp.formatMomentDate(product.prod_commission_at) }}</p>
							</b-col>
						</b-row>
						<CasesAddBankModal :show_add_bank.sync="modals.show_add_bank" :product="product"/>
        </b-container>
			</div>
    </el-drawer>
</template>
<script>
import { Drawer, Collapse, CollapseItem, Button } from 'element-ui'
import PropertyDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/PropertyDetails'
import BankDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/BankDetails'
import LawyerDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/LawyerDetails'
import SpaRemarks from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/SpaRemarks'
import LaRemarks from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/LaRemarks'
import CasesAddBankModal from '@/views/CustomerProfile/CustomerModals/CasesAddBankModal'
import CaseProgress from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/CaseProgress'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useHestiaStore } from '@/stores/hestiaStore'
import {
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import DisableCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/DisableCaseCard'
import {UNEDITABLE_STATUS} from '@/assets/js/status.js'

export default {
    components: {
        DisableCaseCard,
        PropertyDetails,
        BankDetails,
        LawyerDetails,
        SpaRemarks,
        LaRemarks,
				CaseProgress,
        CasesAddBankModal,
        [Drawer.name]: Drawer,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
    },
    data() {
        return {
						product:null,
            is_visible: false,
            is_loading: false,
            modals: {
                show_add_bank: false
            },
            banks:[],
            activeNames:['1','2'],
            pmp_case_details: null,
            is_loading_sync: false,
            cover_image: null,
						UNEDITABLE_STATUS:UNEDITABLE_STATUS,
            lawyer_trackings: {
                spa: {
                    trackings:[],
                    remarks: []
                },
                la: {
                    trackings:[],
                    remarks: []
                }
            },
        }
    },
    mounted(){
      caseEventBus.$on('update-pmp-case-detail', this.updatePMPCaseDetails);
    },
    beforeUnmount(){
			caseEventBus.$off('update-pmp-case-detail', this.updatePMPCaseDetails)
    },
    mounted(){
      caseEventBus.$on('update-pmp-case-detail', this.updatePMPCaseDetails);
    },
    beforeUnmount(){
			caseEventBus.$off('update-pmp-case-detail', this.updatePMPCaseDetails)
    },
    methods: {
        ...mapActions(useProductStore, ['getCustomerProducts', 'getProduct', 'setProducts','checkCanGenerateCommision','generateProductCommission']),
        ...mapActions(useHestiaStore, ['getHestiaCaseDetails', 'getHestiaProjectCoverImage', 'getHestiaLawyerTracking','getChangeUnitList']),
				async show(product_id) {
						this.is_loading = true
						this.is_visible = true
						this.product = await this.getProduct(product_id);
            await this.setProducts([this.product])
						if(!_gHlp.isEmpty(this.product)){
							if(this.is_visible && !['Application Pending', 'Application Rejected'].includes(this.product.prod_main_status)){
								if(this.product.product_detail.prod_pm_property_src == 'HESTIA') {
                    this.pmp_case_details = null;
                    this.pmp_case_details = await this.getHestiaCaseDetails(this.product.product_detail.prod_pm_unit_id)
                    const result = await this.getChangeUnitList(this.product.product_detail.prod_pm_property_id)
                    this.pmp_case_details.change_unit_list = result.unit_listing_group_by_level.flat();
                    this.cover_image = await this.getHestiaProjectCoverImage(this.product.product_detail.prod_pm_property_id)
                    this.lawyer_trackings = await this.getHestiaLawyerTracking(this.product.prod_id)
                    if(this.lawyer_trackings == null)
                    {
                        this.lawyer_trackings = {
                            spa: {
                                trackings:[],
                                remarks: []
                            },
                            la: {
                                trackings:[],
                                remarks: []
                            }
                        }
                    }
                } else {
                    await this.getPMPCaseDetails()
                }
							}
						}
						this.is_loading = false
        },
				hide(){
					this.product = null
				},
				showAddBankModal(){
            this.modals.show_add_bank = true
            this.activeNames.push('2')
        },
        async getPMPCaseDetails(){
            try{
                this.pmp_case_details = null
                const res = await axios.get(services.lookup + 'pmp/cases.im2uv2/'+this.product.prod_id, {headers: getHeader()})
                this.pmp_case_details = res.data
            }catch(e){
                _gNotif.errorFunction(e)
            }
        },
        updatePMPCaseDetails(data){
            if(data){
                this.pmp_case_details = data
            }
        },
    }
}
</script>